<template>
  <div class="ispages">
    <div v-for="(item, index) in dataList" :key="index" class="dietItem">
      <div class="dietItem-flex">
        <div class="dietItem-flex-name">{{ item.name }}</div>
        <div>
          <span class="dietItem-flex-blackWeight">{{ item.engine }}</span>
          <span class="dietItem-flex-text">/{{ item.suggestEngine }}千卡</span>
        </div>
      </div>
      <div v-if="item.dishes && item.dishes.length">
        <div v-for="(food, i) in item.dishes" :key="i" class="dietItem-flex">
          <div class="flex">
            <div class="dietItem-flex-blackWeight">
              <img src="@/assets/image/B6.png" alt="" />
            </div>
            <div class="dietItem-flex-FoodName">
              <div class="dietItem-flex-FoodName-name">
                {{ food.name }}
                <img
                  class="dietItem-flex-FoodName-img"
                  src="@/assets/card_btn_health@2x.png"
                  alt=""
                />
              </div>
              <div class="dietItem-flex-FoodName-number">
                {{ food.weight }}g
              </div>
            </div>
          </div>
          <div class="flex dietItem-flex-text">
            <div>{{ food.engine }}千卡</div>
          </div>
        </div>
      </div>
      <div v-else class="dietItem-none">{{ item.name }}暂无记录</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: Array,
  },
  data() {
    return {
      tableData: [
        {
          name: "早餐",
          number: 0,
          units: "千卡",
          list: [],
        },
        {
          name: "午餐",
          number: 0,
          units: "千卡",
          list: [],
        },
        {
          name: "晚餐",
          number: 0,
          units: "千卡",
          list: [],
        },
      ],
    };
  },
  watch: {},
  methods: {},
};
</script>

<style lang="less" scoped>
.ispages {
  padding: 10px;
  padding-bottom: 25px;
  background: #fff;
  box-sizing: border-box;
  font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
}
.ispages > .dietItem:last-child {
  border: none;
}
.dietItem {
  border-bottom: 1px solid #e6e6e6;
  &-none {
    font-size: 15px;
    font-weight: 400;
    color: #808080;
    text-align: center;
    height: 40px;
  }
  &-flex {
    display: flex;
    justify-content: space-between;
    .flex {
      display: flex;
      height: 60px;
    }
    &-name {
      font-size: 17px;
      font-weight: 400;
      color: #202020;
      line-height: 50px;
    }
    &-blackWeight {
      font-size: 15px;
      font-weight: 400;
      color: #202020;
      img {
        width: 48px;
        height: 48px;
        border-radius: 4px 4px 4px 4px;
      }
    }
    &-FoodName {
      font-size: 15px;
      font-weight: 400;
      color: #202020;
      line-height: 24px;
      margin-left: 10px;
      &-name {
        position: relative;
      }
      &-img {
        width: 68px;
        height: 20px;
        position: absolute;
        margin-top: 1px;
      }
      &-number {
        font-size: 12px;
        font-weight: 400;
        color: #909090;
      }
    }
    &-text {
      font-size: 13px;
      font-weight: 400;
      color: #808080;
      line-height: 20px;
    }
  }
}
</style>